import { render } from "./EmployeePendingPayments.vue?vue&type=template&id=0be0c2b8"
import script from "./EmployeePendingPayments.vue?vue&type=script&lang=js"
export * from "./EmployeePendingPayments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__